import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { IonContent } from '@ionic/angular';
import { first } from 'rxjs/operators';
import { Navigator } from 'src/app/components/menu/navigator';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';
import { isUndefined } from 'src/app/services/codeUtils';
import { ConfigService } from 'src/app/services/config/config.service';
import { EventsService } from 'src/app/services/event/event.service';
import { LogoutService } from 'src/app/services/logout/logout.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';

@Component({
  selector: 'app-update-house-rules',
  templateUrl: './update-house-rules.component.html',
  styleUrls: ['./update-house-rules.component.scss'],
})
export class UpdateHouseRulesComponent implements OnInit {
  @ViewChild('Content') content: IonContent;
  @Input() customerId: any;
  @Input() callback;

  public error = null;
  public buttonDisabled = false;
  public feautureCustomerSupportURL: string;
  public timerId: any;

  constructor(
    public events: EventsService,
    private userSession: UserSessionService,
    private config: ConfigService,
    private navigator: Navigator,
    private appLinks: AppLinksService,
    private logoutService:LogoutService
  ) {
    this.events.publish("event:lobby:hide");

    this.timerId = setTimeout(()=> {
      this.closeModal();
    },300000);
  }

  ngOnInit() {
    this.feautureCustomerSupportURL = this.config.getConfig().FEATURE_CUSTOMER_SUPPORT_URL || '';
  }

  public onAgree() {
    this.buttonDisabled = true;
    this.userSession.acceptHouseRules(this.customerId).pipe(first()).subscribe(
      response => {
        if (!isUndefined(response) && !!response.result) {
          if (!!this.callback) {
            this.callback();
            this.navigator.dismiss();
          }
          clearTimeout(this.timerId);
        } else {
          this.logoutService.onLogout({reason:'TOC_INVALID'});
        }
      },
      error => this.logoutService.onLogout( {reason:'TOC_INVALID'})
    )
  }

  goToHouseRulesLink() {
    // this.appLinks.goToWebviewPopover('/house-rules');
    return false;
  }

  goToFeautureCustomerSupportURL() {
      this.appLinks.openExternalPage(this.feautureCustomerSupportURL);
      return false;
  }

  closeModal = () => {
    this.navigator.dismiss();
    this.logoutService.onLogout({reason:'TOC_INVALID'});
  }

}
